/**
 * Provide helper functions related to ressources paths (URI & URL).
 */
export class RessourcePathHelper {

    /**
     * Gets the absolute path of the giving base path using the root path.
     * 
     * @param basePath - The base ressource path
     * @param resourcePath - The root path of the ressource
     */
    public static getAbsolutePath(basePath: string, resourcePath: string) {

        // Patch IE, detecte les URL en absolus
        if (resourcePath.startsWith("/C:")) {
            resourcePath = resourcePath.replace("/C:", '');
        }

        // See if there is already a protocol on this
        if (resourcePath.indexOf("://") !== -1) {
            return resourcePath;
        }

        // See if using javascript call
        if (resourcePath.startsWith("javascript:")) {
            return resourcePath;
        }

        // See if this is protocol-resourcePath
        if (resourcePath.indexOf("//") === 0) {
            const protocolIndex: number = basePath.indexOf("://");
            return basePath.substr(0, protocolIndex + 1) + resourcePath;
        }

        // We need to split the domain and the path for the remaining options
        const protocolIndexEnd: number = basePath.indexOf("://") + 3;

        // append slash if passed only http://bla.com
        if (basePath.indexOf("/", protocolIndexEnd) === -1) {
            basePath += "/";
        }

        const endDomainIndex: number = basePath.indexOf("/", protocolIndexEnd);
        const domain: string = basePath.substr(0, endDomainIndex);
        let path: string = basePath.substr(endDomainIndex);

        // trim off any ending file name
        if (path.lastIndexOf("/") !== path.length - 1) {
            path = path.substr(0, path.lastIndexOf("/") + 1);
        }

        // See if this is site-absolute
        if (resourcePath.indexOf("/") === 0) {
            return domain + resourcePath;
        }

        // See if this is document-relative with ../
        while (resourcePath.indexOf("../") === 0) {
            resourcePath = resourcePath.substr(3);
            if (path.length > 1) {
                const secondToLastSlashIndex: number = path.substr(0, path.length - 1).lastIndexOf("/");
                path = path.substr(0, secondToLastSlashIndex + 1);
            }
        }

        // Finally, slap on whatever ending is left
        return domain + path + resourcePath;
    }
}
